module.exports = __webpack_public_path__ + "static/img/barra_7.2f901c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_7.png
// module id = lKS3
// module chunks = 1